var r;!function(r){r.Primary="primary",r.Secondary="secondary",r.TextPrimary="textPrimary",r.TextSecondary="textSecondary"}(r||(r={}));export{r as ButtonVariantEnum};
